import { useNavigate } from "react-router"
import { useQueryClient } from "@tanstack/react-query"
import { useLogout } from "../../../hooks"

export function useBirddogLogout(
  config: { onSuccess?: (...args: any[]) => void } = {}
) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useLogout(queryClient, {
    ...config,
    onSuccess: (data, ...args) => {
      navigate("/birddog/login")
      if (config.onSuccess) {
        config.onSuccess(data, ...args)
      }
    },
  })
}
